import { globalVariables } from "helper/globalVariables";
import { useForm } from "react-hook-form";
import { BottomButtons } from "shared/Components/bottomButtons";
import { Header, UserLoginHeader } from "shared/Components/header";
import { TextInput } from "shared/Components/textInput";
import { registerDogResolver } from "validators/UserValidation";
import "./modules.css";
import { FileUpload } from "shared/Components/fileUpload";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Dropdown from "shared/Components/dropdown";
import { SearchDropdown } from "shared/Components/searchDropdown";
import Accordion from "shared/Components/accordian";
import { CheckBox } from "shared/Components/checkbox";
import { dog } from "helper/images";
import { useNavigate, useLocation } from "react-router-dom";
import CustomDateOfBirthPicker from "shared/Components/dateOfBirthPicker";
import { SkipModal } from "./Components/SkipModal";
import { AddHandler } from "shared/Components/addHandler";
import { useDispatch, useSelector } from "react-redux";
import { setDogsAction } from "redux/features/dogSlice/dogReducerSlice";
import { useUploadImage } from "redux/hooks";
import { TextButton } from "shared/Components/textButton";
import { setRefresh } from "redux/globalSlice";
import { StepsHeader } from "shared/Components/stepsHeader";
import { breedDropdown } from "./Constants/breeds";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { useQuery } from "@apollo/client";
import { getDogsQuery, REGISTER_DOG_FOR_FREE } from "redux/features/dogSlice/dogGql";
import { OutlineButton } from "shared/Components/outlineButton";
import { logout } from "helper/icons";
import { useLogout } from "helper/logout";
import { client } from "helper/apolloConfig";
import moment from "moment";

const initialState = [
  {
    title: globalVariables.dog,
    callName: "",
    registrationName: "",
    breed: "",
    breedMix: "",
    gender: "",
    image: "",
    dob: "",
    isRescueYes: true,
  },
];

export const RegisterDog = forwardRef(
  (
    {
      isCustom = false,
      onPressNext = () => {},
      isProfile = false,
      dogsState = [],
      isEditable = true,
      onRemoveLoader,
    },
    ref
  ) => {
    const [checkValidation, setCheckValidation] = useState(false);
    const dispatch = useDispatch();
    const [accordianIndex, setAccordianIndex] = useState(isProfile ? null : 0);
    const [isAccordianOpen, setIsAccordianOpen] = useState(true);
    const navigate = useNavigate();
    const modalRef = useRef();
    const { dogsData } = useSelector((state) => state.dogs);
    const [dogs, setDogs] = useState(isProfile ? [] : initialState);
    const [oldDogs, setOldDogs] = useState([]);
    const location = useLocation();
    const { onUploadImage, imageUrl } = useUploadImage();
    const errorModalRef = useRef();
    const [apiData, setApiData] = useState({
      title: "",
      desc: "",
      type: "pending",
    });
    const [nextLoading, setNextLoading] = useState(false);
    const { onLogout } = useLogout();

    const { data, loading } = useQuery(getDogsQuery, {
      fetchPolicy: "no-cache",
    });

    useEffect(() => {
      if (imageUrl) {
        onSetImage(imageUrl);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imageUrl]);

    useEffect(() => {
      if (isProfile) {
        const mappedData = dogsState.map((dog, index) => {
          return {
            id: dog.id,
            title: dog?.call_name ?? globalVariables.dog,
            callName: dog?.call_name,
            registrationName: dog?.registration_name,
            breed: dog?.breed,
            breedMix: dog?.breed_mix,
            gender: dog?.gender,
            image: dog?.dogImage,
            dob: dog?.date_of_birth,
            isRescueYes: dog?.rescue,
          };
        });
        setDogs(mappedData);
        setOldDogs(mappedData);
        setShowBreedMixInput(true);
      } else {
        setDogs(dogsData?.length > 0 ? [...dogsData] : initialState);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useImperativeHandle(ref, () => ({
      saveChanges() {
        return onGoNext();
      },
    }));

    // const breedDropdown = ["Mixed Breed", "Labrador Retriever", "Afghan Hound"];
    const genderDropdown = [
      "Male Intact",
      "Male Neutered",
      "Female Intact",
      "Female Spayed",
    ];

    const { handleSubmit } = useForm({
      resolver: registerDogResolver,
      defaultValues: dogs[accordianIndex],
    });

    function findDuplicateDogIndex(dogs) {
      let seenNames = new Set();
      let duplicateIndex = -1;

      dogs.map((dog, index) => {
        if (seenNames.has(dog.registrationName) && duplicateIndex === -1) {
          duplicateIndex = index;
        } else {
          seenNames.add(dog.registrationName);
        }
      });

      return duplicateIndex;
    }

    const onHandleSubmit = () => {
      setCheckValidation(true);
      // console.log("Dogs Data " , dogs , dogs[accordianIndex] , accordianIndex);
      // return;
      const dogData = dogs?.[accordianIndex];
      const isBreedMixed = dogData.breed === "Mixed Breed";

      if (
        dogData.registrationName &&
        dogData.breed &&
        (!isBreedMixed || (isBreedMixed && dogData.breedMix)) && // Validate breedMix only if breed is "Mixed Breed"
        dogData.gender &&
        dogData.dob
      ) {
        setAccordianIndex(null);
      }
    };
    const onCloseModal = () => {
      onRemoveLoader?.();
    };

    const onAddDog = () => {
      if (location.pathname === "/dashboard/myProfile") {
        modalRef.current.openModal();
      } else {
        setDogs([
          ...dogs,
          {
            title: globalVariables.dog,
            callName: "",
            registrationName: "",
            breed: "",
            breedMix: "",
            gender: "",
            image: "",
            dob: "",
            isRescueYes: true,
          },
        ]);
        setAccordianIndex(dogs?.length);
        setCheckValidation(false);
      }
    };

    const onChangeIndex = (index) => {
      setCheckValidation(false);
      setAccordianIndex(index === null ? 0 : index);
      setIsAccordianOpen(index !== null);
    };
    const [showBreedMixInput, setShowBreedMixInput] = useState(false);

    const onChangeBreed = (option) => {
      const dogsArr = [...dogs];
      dogsArr[accordianIndex] = {
        ...dogsArr[accordianIndex],
        breed: option,
      };
      setDogs(dogsArr);
      const isMixedBreed = ["Mixed Breed", "Mixed Breed - Designer Dogs", "Other"].includes(option);
      setShowBreedMixInput(isMixedBreed);
    };

    const onChangeBreedMix = (e) => {
      if (!e.target.value.startsWith(" ")) {
        const dogsArr = [...dogs];
        dogsArr[accordianIndex] = {
          ...dogsArr[accordianIndex],
          breedMix: e.target.value,
        };
        setDogs(dogsArr);
      }
    };

    const onChangeGender = (option) => {
      const dogsArr = [...dogs];
      dogsArr[accordianIndex] = {
        ...dogsArr[accordianIndex],
        gender: option,
      };

      setDogs(dogsArr);
    };

    const onSetImage = (img) => {
      const dogsArr = [...dogs];
      dogsArr[accordianIndex].image = img;
      setDogs(dogsArr);
    };

    const onSetDate = (date) => {
      const dogsArr = [...dogs];
      dogsArr[accordianIndex] = {
        ...dogsArr[accordianIndex],
        dob: date,
      };
      setDogs(dogsArr);
    };

    const onChangeCallName = (e) => {
      if (!e.target.value.startsWith(" ")) {
        const dogsArr = [...dogs];
        dogsArr[accordianIndex] = {
          ...dogsArr[accordianIndex],
          callName: e.target.value,
        };
        setDogs(dogsArr);
      }
    };

    const onChangeRegistrationName = (e) => {
      if (!e.target.value.startsWith(" ")) {
        const dogsArr = [...dogs];
        dogsArr[accordianIndex] = {
          ...dogsArr[accordianIndex],
          registrationName: e.target.value,
        };
        setDogs(dogsArr);
      }
    };

    const onGoBack = () => {
      if (isCustom) {
        navigate("/dashboard/memberDashboard");
      } else {
        navigate("/member/registerMember");
      }
    };

    const handleCheckbox = (value) => {
      // debugger;
      const dogsArr = [...dogs];
      dogsArr[accordianIndex].isRescueYes = value;
      setDogs(dogsArr);
    };

    function hasDuplicateRegistrationNames(dogs) {
      const namesSet = new Set();

      for (const dog of dogs) {
        if (namesSet.has(dog.registrationName)) {
          return true;
        }
        namesSet.add(dog.registrationName);
      }

      return false;
    }

    function hasCommonRegistrationNames(regDogs, newDogs) {
      const namesSet = new Set();

      for (const dog of regDogs) {
        namesSet.add(dog.registration_name);
      }

      for (let index = 0; index < newDogs.length; index++) {
        const newDog = newDogs[index];
        const oldDog = oldDogs[index];

        if (newDog?.registrationName !== oldDog?.registrationName) {
          if (namesSet.has(newDog.registrationName)) {
            return true;
          }
        }
      }

      return false;
    }

    const onGoNext = async () => {
      let hasDup = hasDuplicateRegistrationNames(dogs);
      if (hasDup) {
        errorModalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.error,
          desc: "Multiple Dogs Can not have same registration name",
          type: "pending",
        });

        return;
      }
      const hasDogAlready = hasCommonRegistrationNames(
        data?.getMyRegisteredDogs,
        dogs
      );
      if (hasDogAlready) {
        errorModalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.error,
          desc: "Dog with this registration name already exists , Please register with a different name",
          type: "pending",
        });
        return;
      }
      for (let index = 0; index < dogs?.length; index++) {
        const dog = dogs[index];
        const isBreedMixed = dog.breed === "Mixed Breed";
        if (
          !(
            dog.callName &&
            dog.breed &&
            (!isBreedMixed || (isBreedMixed && dog.breedMix)) &&
            dog.gender &&
            dog.dob
          )
        ) {
          setAccordianIndex(index);
          setCheckValidation(true);
          return;
        }
      }

      if (isProfile) {
        return dogs;
      } else {
        // Create dogs immediately with Pending/Unpaid status
        try {
          setNextLoading(true);

          const dogsList = dogs.map((dog) => {
            return {
              call_name: dog?.callName,
              registration_name: dog?.registrationName,
              breed: dog?.breed,
              breed_mix: dog?.breedMix,
              gender: dog?.gender,
              date_of_birth: moment(dog?.dob).format(),
              rescue: dog?.isRescueYes,
              dogImage: dog?.image,
            };
          });

          const result = await client.mutate({
            mutation: REGISTER_DOG_FOR_FREE,
            variables: {
              data: dogsList,
            },
          });

          if (result.data && result.data.registerDogForFree) {
            // Update Redux state with the newly created dogs from backend
            // This ensures MakePayment page has the correct data format
            const createdDogs = result.data.registerDogForFree.data;
            dispatch(setDogsAction(createdDogs));

            if (isCustom) {
              onPressNext();
            } else {
              navigate("/member/makePayment?forUnPaid=true");
            }
          }
          setNextLoading(false);
        } catch (ex) {
          setNextLoading(false);
          errorModalRef.current.openModal();
          setApiData({
            ...apiData,
            title: globalVariables.error,
            desc: ex?.message || "Error creating dog registration",
            type: "pending",
          });
        }
      }
    };
    const onRemove = (index) => {
      const dogsArr = [...dogs];
      dogsArr.splice(index, 1);

      setDogs(dogsArr);
    };
    const renderAccordianBody = () => {
      if (dogs?.length === 0) return <></>;
      return (
        <div>
          <FileUpload
            icon={dog}
            width={"w-[100%] md:w-[350px] lg:w-[350px]"}
            onSetImage={(img) => onUploadImage(img)}
            defaultImage={dogs[accordianIndex]?.image}
            disabled={!isEditable}
          />
          <div className="mt-4" />
          <form onSubmit={handleSubmit((d) => {})}>
            <TextInput
              placeholder={globalVariables.enterCallName}
              errorMsg={
                dogs[accordianIndex]?.callName
                  ? ""
                  : checkValidation
                  ? globalVariables.callNameRequired
                  : ""
              }
              onChange={onChangeCallName}
              value={dogs[accordianIndex]?.callName}
              disabled={!isEditable}
            />
            <div className="mt-4" />
            <TextInput
              placeholder={globalVariables.enterRegisteredName}
              // errorMsg={
              //   dogs[accordianIndex]?.registrationName
              //     ? ""
              //     : checkValidation
              //     ? globalVariables.registrationNameRequired
              //     : ""
              // }
              onChange={onChangeRegistrationName}
              value={dogs[accordianIndex]?.registrationName}
              disabled={!isEditable}
              maxLength={100}
            />
            <div className="mt-5" />
            <CustomDateOfBirthPicker
              isNavigation
              onSetDate={onSetDate}
              defaultDate={
                dogs[accordianIndex]?.dob
                  ? new Date(dogs[accordianIndex]?.dob)
                  : ""
              }
              width="w-[100%]"
              placeholder={globalVariables.dateOfBirth}
              checkValidation={checkValidation}
              disabled={!isEditable}
              maxDate={new Date()}
            />
            <div className="mt-5" />
            <SearchDropdown 
              width="w-[100%]"
              dropdownOptions={breedDropdown}
              defaultValue={dogs[accordianIndex]?.breed}
              placeholder={globalVariables.breed}
              checkValidation={checkValidation}
              onSelectOption={onChangeBreed}
              disabled={!isEditable}
              errorMsg={
                dogs[accordianIndex]?.breed || !checkValidation
                  ? ""
                  : globalVariables.selectBreed
             }
            />
            {showBreedMixInput && (
                <>
                  <div className="mt-5" />
                  <TextInput
                    placeholder={globalVariables.specifyBreed}
                    errorMsg={
                      dogs[accordianIndex]?.breedMix
                        ? ""
                        : checkValidation
                        ? globalVariables.breedMixRequired
                        : ""
                    }
                    onChange={onChangeBreedMix}
                    value={dogs[accordianIndex]?.breedMix}
                    disabled={!isEditable}
                  />
                </>
              )}
            <div className="mt-5" />
            <Dropdown
              dropdownOptions={genderDropdown}
              placeholder={globalVariables.gender}
              checkValidation={checkValidation}
              defaultOption={dogs[accordianIndex]?.gender}
              width="w-[100%]"
              onChange={onChangeGender}
              disabled={!isEditable}
              errorMsg={
                dogs[accordianIndex]?.gender || !checkValidation
                  ? ""
                  : globalVariables.selectGender
              }
            />
            <div className="mt-5" />
            <div className="flex flex-row justify-between">
              <span className="text-base font-medium text-gray-700">
                {globalVariables.rescue}
              </span>
              <div className="flex flex-row">
                <CheckBox
                  label={globalVariables.yes}
                  isChecked={dogs[accordianIndex]?.isRescueYes}
                  onChange={() => {
                    if (isEditable) {
                      handleCheckbox(true);
                    }
                  }}
                />
                <div className="mr-4" />
                <CheckBox
                  label={globalVariables.no}
                  isChecked={!dogs[accordianIndex]?.isRescueYes}
                  onChange={() => {
                    if (isEditable) {
                      handleCheckbox(false);
                    }
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      );
    };

    const additionalProps = isCustom
      ? {}
      : {
          onTapHyperlink: () => modalRef.current.openModal(),
          hyperlinkLabel: `${globalVariables.Skip}?`,
        };
        
    useEffect(() => {
      window.scroll(0, 0);
    }, []);
  
    return (
      <>
        {!isProfile &&
          (location.pathname !== "/dashboard/registerDog" ? (
            <Header
              rightComponent={
                <OutlineButton
                  icon={logout}
                  label={globalVariables.logout}
                  prefix={false}
                  width="w-[123px]"
                  onClick={onLogout}
                />
              }
            />
          ) : (
            <UserLoginHeader />
          ))}
        <div className="bg-white my-6 py-2 pb-10">
        <div className="border rounded-md shadow-100 flex justify-center p-2 md:p-10 flex-col items-center bg-white w-100 md:w-[500px] m-auto">
          {isProfile && (
            <span className="text-2xl md:text-3xl font-semibold text-gray-900 mb-6">
              {globalVariables.dogDetails}
            </span>
          )}
          {!isProfile && (
            <>
              <span className="text-2xl md:text-3xl font-semibold text-gray-900 mb-6">
                {globalVariables.registerDog}
              </span>
              {!isCustom && (
                <>
                  <StepsHeader
                    step={2}
                    labels={[
                      globalVariables.registerMember,
                      globalVariables.registerDog,
                      globalVariables.makePayment,
                    ]}
                  />
                  <div className="mt-10" />
                </>
              )}

              {/* <span className="text-xl font-semibold text-gray-900 mb-1">
                {globalVariables.addDogDetails}
              </span> */}
              <span className="text-base font-regular text-gray-500 w-[] w-[358px] lg:w-[384px] max-[400px]:w-[90%]">
                {globalVariables.oneTimeRegistration}
              </span>
            </>
          )}
          <div className="mt-6" />
          <Accordion
            items={dogs}
            children={renderAccordianBody()}
            onChangeIndex={onChangeIndex}
            defaultIndex={accordianIndex}
            hasRemove={!isProfile}
            onRemove={onRemove}
            hasLabel={true}
          />
          <div className="w-[358px] lg:w-[384px] max-[400px]:w-[90%]">
            <AddHandler onAdd={onAddDog} label={globalVariables.addAnotherDog} />
          </div>
        </div>
        </div>


        <PopUpMessages
          title={apiData.title}
          desc={apiData.desc}
          type={apiData.type}
          ref={errorModalRef}
          onCloseModal={onCloseModal}
        />

        {!isProfile && (
          <>
            <BottomButtons
              outlineLabel={globalVariables.back}
              onTapYes={onGoNext}
              onTapNo={onGoBack}
              position={"sticky"}
              loading={nextLoading}
              {...additionalProps}
            />
            <SkipModal
              ref={modalRef}
              onSkip={() => {
                dispatch(setRefresh());
              }}
            />
          </>
        )}
        {location.pathname === "/dashboard/myProfile" ? (
          <SkipModal
            ModalHeader={globalVariables.registerDogRequired}
            ModalContent={globalVariables.registerDogSubText}
            ref={modalRef}
            onSkip={() => navigate("/dashboard/registerDog")}
          />
        ) : (
          ""
        )}
      </>
    );
  }
);
